import { RouteNames } from "@/router/routes";
import Login from "@/views/Enter/Login.vue";
import Registration from "@/views/Enter/Registration.vue";
import RouterView from "@/components/common/RouterView.vue";
const enterRoutes = [
    {
        path: "/enter",
        name: RouteNames.ENTER,
        component: RouterView,
        redirect: { name: RouteNames.ENTER_LOGIN },
        children: [
            {
                path: "login",
                name: RouteNames.ENTER_LOGIN,
                component: Login,
            },
            {
                path: "login/:email",
                name: RouteNames.ENTER_LOGIN_EMAIL,
                component: Login,
            },
            {
                path: "registration",
                name: RouteNames.ENTER_REGISTRATION,
                component: Registration,
            }
        ]
    }
];
export default enterRoutes;
